module.exports = __webpack_public_path__ + "static/gogleads-e519f3da30f0cde9b80a2cec79009ab5.png";